import { StorageItem } from 'shared-utils/file-system';

import { StorageLocation } from '../../communication';
import { getStorageLocationPath } from '../helpers';

export function createStorageItem(storageLocation: StorageLocation, rootPath: string | undefined = undefined): StorageItem {
  const storageLocationPath: string = getStorageLocationPath(storageLocation, rootPath);

  return {
    id: storageLocationPath,
    type: storageLocation.type,
    title: storageLocation.name
      ? storageLocation.name
      : storageLocationPath,
  };
}
